export default __webpack_public_path__ + "static/media/quadrin-group.f7447739.png";